import { deleteRequest } from '@/core';
import { savedLoadPlanningSearches } from '@/requests';

export default async function deleteSavedLoadPlanningSearchRequest(id) {
	let url = savedLoadPlanningSearches.getByIdPath(id);
	let response = await deleteRequest(url);
	return response;
}
